import { axiosClient } from './axios-client';
import type { CertificadoSiiStatus, FolioSiiActivo, TimbrajeResult } from '../../domain/dtos';

/**
 * Repositorio para consultas SII (Servicio de Impuestos Internos)
 */
export const siiRepository = {
  /**
   * Obtener estado del certificado digital
   */
  async getCertificateStatus(): Promise<CertificadoSiiStatus> {
    const { data } = await axiosClient.get('/sii/certificates/status');
    return data;
  },

  /**
   * Obtener folios activos
   */
  async getActiveFolios(): Promise<FolioSiiActivo[]> {
    const { data } = await axiosClient.get('/sii/folios/active');
    return data;
  },

  /**
   * Subir archivo XML de folios
   */
  async uploadFolios(file: File): Promise<void> {
    const formData = new FormData();
    formData.append('file', file);
    
    await axiosClient.post('/sii/folios', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  /**
   * Timbrar folios de boleta electrónica (tipo 39) vía el scraper SII y cargarlos
   * automáticamente al sistema. Requiere suscripción premium (validado en el backend).
   * La operación es lenta (puede tardar ~30-60s), por eso el timeout extendido.
   */
  async prepararTimbraje(
    cantidadFolios: number,
    desactivarLotesVigentes: boolean
  ): Promise<TimbrajeResult> {
    const { data } = await axiosClient.post(
      '/sii/folios/preparar-timbraje',
      { cantidadFolios, desactivarLotesVigentes },
      { timeout: 120000 }
    );
    return data;
  },

  /**
   * Subir certificado digital
   */
  async uploadCertificate(
    file: File,
    rutRepresentative: string,
    password: string,
    repeatPassword: string
  ): Promise<void> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('rutRepresentative', rutRepresentative);
    formData.append('password', password);
    formData.append('repeatPassword', repeatPassword);
    
    await axiosClient.post('/sii/certificates', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};
